import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';
import './auth.css';

function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    phone_number: '',
    password: '',
    password_confirmation: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value || '',
    }));
    setError(null);
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setErrors({});

    try {
      const response = await fetch(`${API_BASE_URL}/supplier/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        // Save token and user data
        localStorage.setItem('supplier_token', data.data.token);
        localStorage.setItem('supplier_user', JSON.stringify(data.data.user));
        
        console.log('Registration successful, redirecting to dashboard...');
        
        // Redirect to dashboard
        navigate('/supplier-dashboard', { replace: true });
      } else {
        if (data.errors) {
          setErrors(data.errors);
        }
        setError(data.message || 'فشل التسجيل');
      }
    } catch (err) {
      console.error('Register error:', err);
      setError('حدث خطأ أثناء التسجيل');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <i className="fas fa-user-plus"></i>
          <h2>تسجيل حساب جديد - المورد</h2>
          <p>أنشئ حسابك للوصول إلى لوحة التحكم</p>
        </div>

        {error && (
          <div className="alert alert-error">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>
              <i className="fas fa-user"></i>
              الاسم الكامل
            </label>
            <input
              type="text"
              name="name"
              value={formData.name || ''}
              onChange={handleChange}
              placeholder="أدخل اسمك الكامل"
              required
            />
            {errors.name && (
              <div className="field-error">
                {errors.name[0]}
              </div>
            )}
          </div>

          <div className="form-group">
            <label>
              <i className="fas fa-phone"></i>
              رقم الهاتف
            </label>
            <input
              type="tel"
              name="phone_number"
              value={formData.phone_number || ''}
              onChange={handleChange}
              placeholder="07XX XXX XXXX"
              required
            />
            {errors.phone_number && (
              <div className="field-error">
                {errors.phone_number[0]}
              </div>
            )}
          </div>

          <div className="form-group">
            <label>
              <i className="fas fa-lock"></i>
              كلمة المرور
            </label>
            <input
              type="password"
              name="password"
              value={formData.password || ''}
              onChange={handleChange}
              placeholder="••••••••"
              required
              minLength="8"
            />
            {errors.password && (
              <div className="field-error">
                {errors.password[0]}
              </div>
            )}
          </div>

          <div className="form-group">
            <label>
              <i className="fas fa-lock"></i>
              تأكيد كلمة المرور
            </label>
            <input
              type="password"
              name="password_confirmation"
              value={formData.password_confirmation || ''}
              onChange={handleChange}
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                جاري التسجيل...
              </>
            ) : (
              <>
                <i className="fas fa-user-plus"></i>
                تسجيل حساب جديد
              </>
            )}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            لديك حساب بالفعل؟{' '}
            <a href="/supplier-login" onClick={(e) => { e.preventDefault(); navigate('/supplier-login'); }}>
              سجل الدخول
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register;

